import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface Provincia {
  id: string;
  nombre: string;
  id_pais: number;
}

export interface Localidad {
  id: string;
  nombre: string;
  provincia_id: string;
}

/**
 * Lista todas las provincias ordenadas por nombre.
 * Catalogo estable: cachea 30 minutos.
 */
export function useProvincias() {
  return useQuery({
    queryKey: ['provincias'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('provincias')
        .select('*')
        .order('nombre');
      if (error) throw error;
      return (data ?? []) as Provincia[];
    },
    staleTime: 30 * 60_000,
  });
}

/**
 * Lista localidades filtradas por provincia.
 * Si no hay provincia, devuelve array vacio (evita traer 2.000+ localidades).
 */
export function useLocalidades(provinciaId: string | null | undefined) {
  return useQuery({
    queryKey: ['localidades', provinciaId],
    queryFn: async () => {
      if (!provinciaId) return [];
      const { data, error } = await supabase
        .from('localidades')
        .select('*')
        .eq('provincia_id', provinciaId)
        .order('nombre');
      if (error) throw error;
      return (data ?? []) as Localidad[];
    },
    enabled: !!provinciaId,
    staleTime: 30 * 60_000,
  });
}
